import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Icon} from 'antd';

import {setIcon} from '../../services/setIcon';

import './style.css';

const DateText = ({dateStr}) => {
  // We use moment again to have the date translated when the language changes, as
  const asDate = moment(new Date(dateStr));
  return asDate.isValid() ? asDate.format('MMMM DD, YYYY') : dateStr;
}

const BookingRoomInfo = ({booking, context}) => {
  const showIcon = booking.rooms > 0 || booking.adults > 0;
  return (
          <div className="flex items-end capitalize">
            {showIcon && (
                    <div className="text-gray-link icon-detail users pr-1 text-lg">
                      <Icon component={setIcon('peoples')}/>
                    </div>
            )}
            {booking.rooms > 0 &&
            <p className="text-xs">{context.t(['{n} room', '{n} rooms', 'rooms'], {n: booking.rooms})}</p>}
            {booking.adults > 0 &&
            <p className="text-xs pl-1">{context.t(['{n} adult', '{n} adults', 'n'], {n: booking.adults})}</p>}
          </div>
  )
};

const DetailsBookingDefault = ({booking, context}) => (
        <div className="flex flex-col mt-1">
          <div className="flex text-xs mb-2 lg:mb-0">
            <Icon component={setIcon('calendar')} className="text-gray-link pr-1 md:pr-2"/>
            <DateText dateStr={booking.checkInDate}/> - <DateText dateStr={booking.checkOutDate}/>
          </div>
          <BookingRoomInfo booking={booking} context={context}/>
        </div>
);

const DetailsBookingComponent = ({mode, booking}, context) => {
  return (
          <div className="flex justify-start">
            <DetailsBookingDefault booking={booking} context={context}/>
          </div>
  );
}

DetailsBookingComponent.propTypes = {
  mode: PropTypes.string,
  booking: PropTypes.object.isRequired,
};

DetailsBookingComponent.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default DetailsBookingComponent;
